import { StoreState } from '@/core/models/store.interface';
import { Module } from 'vuex';
import { Contact } from './contact.interface';
import { ContactService } from './contact.service';

const service = new ContactService();

export interface ContactState {}

const ContactStore: Module<ContactState, StoreState> = {
   namespaced: true,
   state: {},
   getters: {},
   mutations: {},
   actions: {
      async getContacts(context, customerId: number) {
         const response = await service.getContacts(customerId);
         return {
            ...response,
            data: response.data.map((contact: Contact) => ({
               ...contact,
               name: `${contact.first_name} ${contact.last_name}`,
               language: contact.communication_language,
               language_id: contact.communication_language_id,
            })),
         };
      },

      async getContact(context, { customerId, contactId }: { customerId: number; contactId: number }) {
         const response = await service.getContact(customerId, contactId);
         return response.data;
      },

      async postContact(context, { customerId, contact }: { customerId: number; contact: Contact }) {
         const response = await service.postContact(customerId, contact);
         // context.commit('UPDATE_CUSTOMER_LIST', response.data);
         return response.data;
      },

      async putContact(context, { customerId, contactId, contact }: { customerId: number; contactId: number; contact: Contact }) {
         const response = await service.putContact(customerId, contactId, contact);
         return response.data;
      },

      async deleteContact(context, { customerId, contactId }: { customerId: number; contactId: number }) {
         const response = await service.deleteContact(customerId, contactId);
         return response.data;
      },

      async call(
         context,
         { customerId, contactId, hitId, phoneNumber }: { customerId: number; contactId: number; hitId?: number; phoneNumber?: string },
      ) {
         const response = await service.call(customerId, contactId, hitId, phoneNumber);
         return response.data;
      },
      async inviteToVideoRoom(
         context,
         { customerId, videocallRoomId, contactId }: { customerId: number; videocallRoomId: number; contactId: number },
      ) {
         const response = await service.inviteToVideoRoom(customerId, videocallRoomId, contactId);
         return response.data;
      },

      async searchContact(context, payload: { customerId: number; search: string }) {
         const response = await service.searchContact(payload.customerId, payload.search);

         return response.data.map((contact: Contact) => ({
            ...contact,
            name: `${contact.first_name} ${contact.last_name}`,
            language: contact.communication_language,
            language_id: contact.communication_language_id,
         }));
      },
   },
};

export default ContactStore;
